import { Component, OnInit } from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {ProgressSpinnerMode} from "@angular/material/progress-spinner";
import {MasterPassService} from "../../services/master-pass/master-pass.service";
import {InitializeMasterPassQRCodeResponse} from "../../interfaces/master-pass/InitializeMasterPassQRCodeResponse";
import {RedirectRequest} from "../../interfaces/master-pass/RedirectRequest";
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from "@angular/router";
import {Session} from '../../interfaces/session-data';



@Component({
  selector: 'app-master-pass',
  templateUrl: './master-pass.component.html',
  styleUrls: ['./master-pass.component.scss']
})
export class MasterPassComponent implements OnInit {

  paymentMethod: string;
  paymentMethodImg = '';
  redirectUrl;
  controllerUrl;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  //Countdown
  config = { leftTime: 5, format: 's' };

  private callBackBaseUrl: string = environment.baseUrlCallback + "/callback/master/pass";
  hidePgLogo = false;
  sessionData: Session;

  constructor(
    private masterPassService: MasterPassService
  ) {
    sessionStorage.setItem('selected-payment', 'master_pass');
    this.paymentMethod = 'master_pass';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;

  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    // this.controllerUrl = `${environment.production ? 'https://' : 'http://'}${window.location.hostname ? 'localhost:7000' : 'localhost:4200'}}`;
    this.controllerUrl = this.callBackBaseUrl + `/redirect/${sessionStorage.getItem('sessionToken')}`;

    this.masterPassService.initializeQRCode(sessionStorage.getItem('sessionToken')).subscribe((data: InitializeMasterPassQRCodeResponse) => {
      this.redirectUrl = data.redirectUrl;
      const timeout = 5;
      setTimeout(() => {
        // window.location.href = data.redirectUrl;
        // const redirectRequest = <RedirectRequest>({redirectUrl: data.redirectUrl});
        (document.getElementById('masterpass-form') as HTMLFormElement).submit();
        // this.masterPassService.redirectMasterPass(sessionStorage.getItem('sessionToken'), redirectRequest).subscribe();
      }, timeout * 1000);
    });

  }

}
